import { Component, Input, OnInit } from '@angular/core';
import { SCHEDULE_TYPES } from '@finder/shared/constants/app.constants';
import { MEAL_PERIOD_LAYOUT } from './meal-period.constants';

@Component({
    selector: 'finder-meal-period',
    templateUrl: './meal-period.component.html',
    styleUrls: ['./meal-period.component.scss']
})
export class MealPeriodComponent implements OnInit {

    @Input() mealPeriodsOrder: Array<string>;
    @Input() mealPeriods: any;
    @Input() schedules: any;
    @Input() labels: any;
    @Input() scheduleType = 'Operating';
    @Input() layout: MEAL_PERIOD_LAYOUT = MEAL_PERIOD_LAYOUT.detailed;

    public layoutOptions = MEAL_PERIOD_LAYOUT;
    public dinnerShowTimeList: string;
    public scheduleTypes = [];
    public scheduleTypeOptions = SCHEDULE_TYPES;
    private dinnerShowMealTimes: Array<string>;

    ngOnInit() {
        if (this.schedules) {
            this.scheduleTypes = Object.keys(this.schedules);
        }
    }

    // We need to collect all the times and then display it in an ordered fashion
    joinMealTimes(time, first, last) {
        // Reset the array
        if (first) {
            this.dinnerShowMealTimes = [];
        }

        // Add the time to the times array
        this.dinnerShowMealTimes.push(time);

        // We've reached the last time
        if (last) {
            // sort() is unlike other JS array operations in that it alters the source array
            // as well as returning the altered array. So there's no need to assign the result
            this.dinnerShowMealTimes.sort();
            this.dinnerShowTimeList = this.dinnerShowMealTimes.join(', ');
        }
    }
}
